// Environment detection based on URL
export const isStaging = (): boolean => {
  if (typeof window === "undefined") return false;
  const url = window.location.href.toLowerCase();
  return (
    url.includes("stage") ||
    url.includes("staging") ||
    url.includes("localhost") ||
    url.includes("127.0.0.1")
  );
};

// Use this to get environment-specific values
export const getEnvValue = <T>(productionValue: T, stagingValue: T): T => {
  return isStaging() ? stagingValue : productionValue;
};

export const BASE_URL = "https://events.locallive.tv";
export const SE_BASE_URL = "https://sportsengine.com";
export const SEP_BASE_URL = getEnvValue(
  "https://sportsengineplay.com",
  "https://stage.sportsengineplay.com"
);

export const getUtmContent = (content: string) => `utm_content=${content}`;
export const SEP_UTM_BASE_PARAMS = "utm_source=web&utm_campaign=local_live_tv";
export const SEP_SCHOOL_FINDER_UTM_PARAMS = `${SEP_UTM_BASE_PARAMS}&utm_content=find_org&utm_medium=school_finder`;
export const generateSchoolChannelUtmParams = (
  schoolName: string,
  content: string
) =>
  `${SEP_UTM_BASE_PARAMS}&${getUtmContent(content)}&utm_medium=${schoolName}`;
export const SEP_FIND_URL = `${SEP_BASE_URL}/find/organization/66fac366e2075b1399a61ca2?${SEP_SCHOOL_FINDER_UTM_PARAMS}`;

export const NBC_BASE_URL = "https://www.nbcuniversal.com";
export const SEP_HELP_BASE_URL = "https://help.sportsengineplay.com/en";

export const MOVED_TITLE = "We've moved to a new streaming service!";
export const MOVED_SUBTITLE =
  "Same exciting content, FREE of cost, plus many new benefits! Check it out now.";
